import(/* webpackMode: "eager", webpackExports: ["PartnersScreen"] */ "/app/apps/platform-web/components/premium/PartnersScreen.tsx");
